import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Lazy load pages for better initial bundle size
const LandingPage = lazy(() => import('./pages/LandingPage'));
const Marketplace = lazy(() => import('./pages/Marketplace'));

// Loading fallback component
const PageLoader = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-neutral-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-950 mx-auto mb-4"></div>
      <p className="text-lg font-medium text-neutral-700">Loading Prescient Marketplace...</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage onNavigate={() => {}} />} />
            <Route path="/marketplace" element={<Marketplace />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
